import Component from 'react-pure-render/component';
import PropTypes from 'prop-types';
import React from 'react';
import Tab from './Tab.react';

export default class Tabs extends Component {
  static propTypes = {
    children: PropTypes.node,
    onTabClick: PropTypes.func,
    scrollVisibled: PropTypes.bool,
    selectFirstTabOnLoad: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = {
      currentTab: undefined
    };
  }

  componentDidMount() {
    const { currentTab } = this.state;
    if (currentTab !== undefined) {
      return;
    }

    const { selectFirstTabOnLoad } = this.props;
    if (selectFirstTabOnLoad) {
      this.setState({ currentTab: 0 });
      return;
    }

    const activeTabIndex = this.getVisibleTabs().findIndex(
      tab => tab && tab.props && tab.props.active
    );
    if (activeTabIndex !== -1) {
      this.setState({ currentTab: activeTabIndex });
    }
  }

  static defaultProps = {
    onTabClick: () => {},
    scrollVisibled: false,
    selectFirstTabOnLoad: false
  };

  renderTab = (tab, tabIndex) => {
    const classsName =
      'tab-item' +
      (tab.props.hiddenPrint ? ' hidden-print' : '') +
      (tabIndex === this.state.currentTab ? ' active' : '');

    const onClick = () => {
      this.setState({ currentTab: tabIndex });
      this.props.onTabClick(tab.props);
    };

    return (
      <div
        key={`tab-${tabIndex}-${tab.props.name}-${tab.props.title}`}
        className={classsName}
        name={tab.props.name}
        onClick={onClick}
      >
        {tab.props.title}
      </div>
    );
  };

  renderTabContent = (tab, tabIndex) => {
    return (
      <Tab
        key={`tab-${tabIndex}-${tab.props.name}-${tab.props.title}`}
        {...tab.props}
        active={tabIndex === this.state.currentTab}
      />
    );
  };
  getVisibleTabs = () => {
    const visibleTabs = [];
    React.Children.forEach(this.props.children, tab => {
      if (tab && tab.type === Tab && tab.props && !tab.props.hide) {
        visibleTabs.push(tab);
      }
    });
    return visibleTabs;
  };

  getAnotherChildren = () => {
    const anotherChildren = [];
    React.Children.forEach(this.props.children, child => {
      if (!child || child.type !== Tab) {
        anotherChildren.push(child);
      }
    });
    return anotherChildren;
  };

  getActiveTab = () => {
    const visibleTabs = this.getVisibleTabs();
    const { currentTab } = this.state;
    if (currentTab === undefined) {
      return null;
    }
    return visibleTabs[currentTab];
  };

  getActiveTabName = () => {
    const activeTab = this.getActiveTab();
    return activeTab ? activeTab.props.name : null;
  };

  render() {
    const { scrollVisibled } = this.props;

    const visibleTabs = this.getVisibleTabs();

    return (
      <div className="panel-tab">
        <div
          className="panel-tab-selector"
          style={{ overflow: scrollVisibled ? 'auto' : 'none' }}
        >
          {visibleTabs.map(this.renderTab)}
        </div>
        <div className="panel-tab-content">
          {visibleTabs.map(this.renderTabContent)}
          {this.getAnotherChildren()}
        </div>
      </div>
    );
  }
}
